import React from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderOne from "./components/headers/headerOne";
import HeaderTwo from "./components/headers/headerTwo";
import Map from "./components/map";
import LocationAlert from "./components/map/LocationAlert";
import ListContainer from "./components/restaurantList/ListContainer";
import "./fonts.css";
import LoadingModal from "./LoadingModal";
import { getLocationIfEnabled } from "./store/actions";
import { requestRestaurants } from "./store/restaurantsStore";
import { restaurantsLoadingSelector } from "./store/restaurantsStore/selectors";

const App = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(requestRestaurants());
    dispatch(getLocationIfEnabled());
  }, [dispatch]);
  const isFetching = useSelector(restaurantsLoadingSelector);
  return (
    <div>
      {isFetching && <LoadingModal />}
      <div>
        <HeaderOne />
        <LocationAlert />
        <Map />
      </div>
      <div id="header2">
        <HeaderTwo />
        <ListContainer />
      </div>
    </div>
  );
};

export default App;
